var BASWebServices;
(function (BASWebServices) {
    var ServiceOptionController = (function () {
        function ServiceOptionController($scope, $rootScope, wsData) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.wsData = wsData;
            this.$scope.soc = this;
        }
        ServiceOptionController.prototype.showOptionSuitableForServices = function (services) {
            var selectedPipeline = this.wsData.getData()["PIPE"];
            if (!selectedPipeline) {
                return true;
            }
            var servicesInSelectedPipeline = selectedPipeline.split("_");
            for (var _i = 0, _a = services.split(","); _i < _a.length; _i++) {
                var service = _a[_i];
                if (servicesInSelectedPipeline.includes(service)) {
                    return true;
                }
                if (service === "TEXTENHANCE" || service === "AUDIOENHANCE") {
                    return true;
                }
            }
            return false;
        };
        ServiceOptionController.prototype.changeOfInput = function (key, value) {
            console.log("'" + key + "': " + value);
            if (value === undefined) {
                this.$rootScope.$broadcast('messageForBox', 'ERROR', 'You entered a disallowed value. Spaces are not allowed in text inputs.');
                this.wsData.markOptionInvalid(key);
            }
            else {
                this.wsData.markOptionValid(key);
            }
            this.wsData.addOption(key, value);
        };
        return ServiceOptionController;
    }());
    BASWebServices.ServiceOptionController = ServiceOptionController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ServiceOptionController.js.map